import React, { useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import { Link } from "react-router-dom";

const Navi = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMenuOpen, setMenuIsOpen] = useState(false);

  const toggle = () => {
    const menu = document.querySelector(".menu")
    setIsOpen(!isOpen)
    if(isMenuOpen && !isOpen){
      menu.classList.remove("open")
      menu.classList.add("menu-part")
      menu.style.width="0px";
      setMenuIsOpen(false)
    }
  
  };
  const toggle2 = () =>{
    const menu = document.querySelector(".menu")
    setMenuIsOpen(!isMenuOpen);
    if(isMenuOpen){
      menu.classList.remove("open")
      menu.classList.add("menu-part")
      menu.style.width="0px";
      setMenuIsOpen(false)
      }else{
        if(isOpen){
          setIsOpen(false)
        }
      menu.classList.add("open")
      menu.style.position="fixed";
      menu.style.width="200px";
      setMenuIsOpen(true)
      }
    }
   
  ;
  
      
      
  
  

  return (
    <div>
      <Navbar light expand="md" className="navbar fixed-top detail-nav">
      <button onClick={toggle2} className="menu-btn category_btn mr-3"> <img alt="categories" src="/images/hamburger.png"></img></button>
        <NavbarBrand href="/" className="text-light">MovieKing</NavbarBrand>
        <NavbarToggler className="bg-light" onClick={toggle} />
        <Collapse  isOpen={isOpen} navbar>
          <Nav  className="ml-auto" navbar>
            <NavItem>
              <NavLink>
                <Link to="/watch-later" className="link text-light" color="white">Watch List</Link>
              </NavLink>
            </NavItem>
          
        
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}

export default Navi;